import { render, staticRenderFns } from "./vipClass.vue?vue&type=template&id=411f4796&scoped=true"
import script from "./vipClass.vue?vue&type=script&lang=js"
export * from "./vipClass.vue?vue&type=script&lang=js"
import style0 from "./vipClass.vue?vue&type=style&index=0&id=411f4796&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411f4796",
  null
  
)

export default component.exports